import * as React from "react";

function EyeFill(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "EyeFill-EyeFill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EyeFill-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "EyeFill-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9985871,7 C28.094244,7 31.844368,8.51800076 34.7402779,11.035002 C36.7870862,12.8130045 40.181433,16.2330203 44.9243646,21.2950072 L44.9243646,21.2950071 C46.2994774,22.7624907 46.3633797,24.9992731 45.0742058,26.5399942 L44.9264034,26.7069944 L44.5217305,27.1389946 C39.9745098,31.986997 36.69941,35.2749987 34.6954278,37.0029996 C31.8066516,39.4969992 28.0748946,41 23.9986033,41 C19.8988658,41 16.145703,39.4799977 13.2497931,36.958998 C11.2060427,35.1809955 7.81475391,31.7639797 3.07588368,26.7079928 L3.07588362,26.7079928 C1.69961448,25.2395436 1.6365627,23.0007503 2.92808127,21.4600058 L3.07588362,21.2930055 L3.4785182,20.8630055 C8.00637327,16.0429874 11.2631395,12.7699858 13.2477704,11.0430162 C16.1446981,8.52201645 19.89788,7 23.9986352,7 L23.9985871,7 Z M23.9985871,15.0000196 L23.9985867,15.0000196 C18.9319389,15.0000196 14.8246377,19.0294576 14.8246377,24.0000196 C14.8246377,28.9706048 18.9319532,33.0000196 23.9985867,33.0000196 L23.9985863,33.0000196 C29.065234,33.0000196 33.1725352,28.9705907 33.1725352,24.0000196 C33.1725352,19.0294435 29.0652197,15.0000196 23.9985863,15.0000196 L23.9985871,15.0000196 Z M23.9985871,19.0000201 L23.9985873,19.0000201 C26.8133841,18.9998606 29.0953371,21.2383071 29.0955282,23.999757 C29.0956907,26.7611833 26.8139814,28.9998688 23.9991606,29.0000563 C21.2702787,29.0002109 19.0254469,26.891674 18.9070456,24.2170696 L18.9019489,24.0000696 L21.9599319,24.0000696 L21.959932,24.0000696 C23.0267858,24.0004008 23.9134766,23.1937442 23.9934907,22.1500671 L23.9985873,22.0000671 L23.9985873,19.0000201 L23.9985871,19.0000201 Z",
    id: "EyeFill-\u5F62\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default EyeFill;